import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";
import { shuffle } from "lodash";

export type SliderType = BoxProps & {
  layoutProps: any;
};

export const AllowedRandomItems = (layoutProps: any, items: any[]) => {
  let shuffledItems = items;
  if (layoutProps.sliderRandom) {
    shuffledItems = shuffle(items);
  }

  return shuffledItems;
};

export const Slider: FC<SliderType> = ({
  children,
  layoutProps,
  ...props
}: SliderType) => (
  <Box
    {...props}
    data-delay={layoutProps.sliderAutoplayDelay}
    data-animation="slide"
    data-autoplay={layoutProps.sliderAutoplay}
    data-easing="ease"
    data-hide-arrows={layoutProps.sliderHideArrows}
    data-disable-swipe={layoutProps.sliderHideArrows}
    data-autoplay-limit={layoutProps.sliderAutoplayLimit}
    data-nav-spacing={layoutProps.sliderNavigationSpace}
    data-duration={layoutProps.sliderTransitionSpeed}
    data-infinite={layoutProps.sliderInfiniteLooping}
  >
    {children}
  </Box>
);
